import { AfterViewInit, ChangeDetectorRef, Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FechaCertificacionModalComponent } from "../../pago/fecha-certificacion-modal/fecha-certificacion-modal.component";
import * as moment from "moment";
import { EMPTY, forkJoin, of } from "rxjs";
import { catchError, finalize, switchMap } from "rxjs/operators";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { CertificacionPrecio } from "src/app/models/PlanesUsuario/CertificacionPrecio";
import { EmpresaFacturacion } from "src/app/models/PlanesUsuario/DatosFacturacion";
import { Plan } from "src/app/models/PlanesUsuario/Plan";
import { PlanUsuario } from "src/app/models/PlanesUsuario/PlanUsuario";
import { Resumen } from "src/app/models/PlanesUsuario/Resumen";
import { Usuario } from "src/app/models/Usuario/Usuario";
import { DeudaAdicionalPendiente } from "src/app/models/PlanesUsuario/DeudaAdicionalPendiente";
import { DeudaGraciaPendiente } from "src/app/models/PlanesUsuario/DeudaGraciaPendiente";
import { AuthService } from "src/app/modules/auth";
import { ChangeCompanyService } from "src/app/services/changecompany.service";
import { DatosFacturacionService } from "src/app/services/datos-facturacion-service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { PagoUsuarioService } from "src/app/services/pago-usuario.service";
import { ModalCommunicationService } from "src/app/services/payment-modals-communication-service.service";
import { PlanUsuarioService } from "src/app/services/planUsuario.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { UsuarioService } from "src/app/services/usuario.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { WebpayPaymentService } from "src/app/services/webpay-payment.service";
import { SessionUser } from "src/app/shared/models/sessionUser";
import Swal from "sweetalert2";
import { SaldoPagoUi } from "src/app/components/pago/saldo-favor-bloque/saldo-pago-ui";
import { solicitarRefrescoSaldo } from "src/app/services/saldo.service";

@Component({
	selector: "app-modals-regularizacion",
	templateUrl: "./modals-regularizacion.component.html",
	styleUrls: ["./modals-regularizacion.component.scss"],
})
export class ModalsRegularizacionComponent implements OnInit, AfterViewInit {
	@ViewChild("modalCambiarEmpresa") modalCambiarEmpresa!: TemplateRef<any>;
	@ViewChild("modalPagoPlan") modalPagoPlan!: TemplateRef<any>;

	public currentEmisorObject: Emisor;
	public emisoresSource: Emisor[];
	public loading: boolean = false;
	public planes: Plan[];
	public datosFacturacion: EmpresaFacturacion;
	public planActual: PlanUsuario;
	public rowsDatosFacturacion: EmpresaFacturacion[] = [];
	public planSeleccionado: Plan;

	public nuevaFechaCaducidad: moment.Moment;
	public fechaActual = moment();
	public certificaciones: CertificacionPrecio[];

	public user: SessionUser;
	public resumenCuenta: Resumen;
	public tieneEmpresasInactivas: boolean = false;
    public cantidadEmpresasInactivas: number = 0;
    public cantidadEmpresasActivas: number = 0;
	public solicitandoFechaCertificacion = false;
	public deudaAdicionalPendiente: DeudaAdicionalPendiente = new DeudaAdicionalPendiente();
	public pagandoDeudaAdicional = false;
	public deudaGraciaPendiente: DeudaGraciaPendiente = new DeudaGraciaPendiente();
	public pagandoDeudaGracia = false;
	public usuarioBasePuedeAdministrarPlan = false;

	get hayCertificacionesSeleccionadas(): boolean {
		return this.certificaciones && this.certificaciones.some(c => c.solicitada);
	}

	get tieneDeudaAdicionalPendiente(): boolean {
		return this.usuarioBasePuedeAdministrarPlan && (this.deudaAdicionalPendiente?.tieneDeuda ?? false);
	}

	get tieneDeudaGraciaPendiente(): boolean {
		return this.usuarioBasePuedeAdministrarPlan
			&& (this.deudaGraciaPendiente?.tieneDeuda ?? false)
			&& !this.deudaGraciaPendiente?.ventanaEnCurso;
	}

	constructor(
		private modalCommunicationService: ModalCommunicationService,
		private userService: UsuarioService,
		private pagoService: PagoUsuarioService,
		private planUsuarioService: PlanUsuarioService,
		private tokenService: TokenStorageService,
		public datosFacturacionServicce: DatosFacturacionService,
		private webpayService: WebpayPaymentService,
		private changeCompanyService: ChangeCompanyService,
		private authService: AuthService,
		public utilities: UtilitiesService,
		private localStorage: LocalStorageService,
		private ref: ChangeDetectorRef,
		private modalService: NgbModal
	) {
		this.user = this.tokenService.getUser() as SessionUser;
	}

	ngOnInit(): void {
		this.emisoresSource = JSON.parse(this.localStorage.getEmisores() || '[]');
		this.currentEmisorObject = this.emisoresSource
			.find(x => x.emisorId === this.tokenService.getCompany());
			this.actualizarEstadoEmpresas();
		this.modalCommunicationService.triggerCargarDatos$.subscribe(() => {
			this.cargarDatos();
		});
	}
	ngAfterViewInit(): void {
		// Pasa el TemplateRef del modal de pago de plan al servicio
		this.changeCompanyService.setModalPagoPlanTemplate(this.modalPagoPlan);
		this.changeCompanyService.setModalChangeCompanyTemplate(this.modalCambiarEmpresa);
	}

	cargarDatos() {
		this.loading = true;
		this.ref.detectChanges();
		
		const emisorId = this.tokenService.getCompany() as string;
		
		this.planUsuarioService.getInitialData().pipe(
			switchMap((data) => {
				this.user = this.tokenService.getUser() as SessionUser;
				this.planes = data.planes;
				this.certificaciones = data.certificaciones;

				return forkJoin({
					userData: this.userService.getUser(this.user.id, emisorId),
					facturacionData: this.datosFacturacionServicce.getData(this.user.id, emisorId),
					deudaData: this.planUsuarioService.getPendingAdditionalDebt(emisorId).pipe(
						catchError(() => of(new DeudaAdicionalPendiente()))
					)
				});
			}),
			catchError((error) => {
				console.error('Error cargando datos:', error);
				this.handleError(error);
				return EMPTY;
			}),
			finalize(() => {
				this.loading = false;
				this.ref.detectChanges();
			})
		).subscribe(({ userData, facturacionData, deudaData }) => {
			this.usuarioBasePuedeAdministrarPlan = this.hasPlanesUsuario(userData);
			this.handleUserData(userData.data, emisorId);
			this.rowsDatosFacturacion = facturacionData;
			this.datosFacturacion = facturacionData.some((x) => x.emisorId == this.planActual.emisorId)
				? facturacionData.find((x) => x.emisorId == this.planActual.emisorId)!
				: facturacionData[0];
			this.deudaAdicionalPendiente = this.usuarioBasePuedeAdministrarPlan
				? (deudaData ?? new DeudaAdicionalPendiente())
				: new DeudaAdicionalPendiente();

			this.cargarDeudaGracia(emisorId);
		});
	}

	private cargarDeudaGracia(emisorId: string): void {
		const idPlanUsuario = this.planActual?.idPlanUsuario;
		if (!this.usuarioBasePuedeAdministrarPlan || !idPlanUsuario) {
			this.deudaGraciaPendiente = new DeudaGraciaPendiente();
			return;
		}
		this.planUsuarioService.getDeudaGracia(emisorId, idPlanUsuario).pipe(
			catchError(() => of(new DeudaGraciaPendiente()))
		).subscribe((deudaGraciaData) => {
			this.deudaGraciaPendiente = deudaGraciaData ?? new DeudaGraciaPendiente();
			this.ref.detectChanges();
		});
	}

	private hasPlanesUsuario(response: any): boolean {
		return Array.isArray(response?.data?.planesUsuario) && response.data.planesUsuario.length > 0;
	}

	
	private obtenerPlanMasReciente(planesUsuario: PlanUsuario[]): PlanUsuario {
		const planesActivos = planesUsuario.filter(p => p.activo);
		return (planesActivos.length > 0 ? planesActivos : planesUsuario).reduce((masReciente, actual) =>
			new Date(actual.fechaContratacion) > new Date(masReciente.fechaContratacion) ? actual : masReciente
		);
	}

	handleUserData(userData: Usuario, emisorId: string): void {
		if (this.planActual && this.planActual.emisorId != null && this.planActual.emisorId != undefined) {
			//Existe un plan
			let planTemporal = userData.planesUsuario.find((y) => y.emisorId === this.planActual.emisorId);
			if (planTemporal == null || planTemporal == undefined) {
				this.planActual = this.obtenerPlanMasReciente(userData.planesUsuario);
				this.handlePlanActual(userData);
			} else {
				this.planActual = this.obtenerPlanMasReciente(userData.planesUsuario);
				this.certificaciones.forEach((x) => {
					x.solicitada = false;
				});
				userData.certificacionesPendientes.forEach((x) => {
					let certTemp = this.certificaciones.find((z) => z.codigoPrincipal === x.codigoPrincipal);
					certTemp.solicitada = true;
				});
				this.handlePlanActual(userData);
			}
		} else {
			//Es posible que el IdUsuario esté dentro de los planes del usuario
			this.planActual = this.obtenerPlanMasReciente(userData.planesUsuario);
			this.handlePlanActual(userData);
		}

		if (!this.user.configured && this.planActual && this.planActual.pagado && !this.planActual.activo) {
			//En realidad no se debería hacer nada y dejar todo por defecto.
			//this.handleNotPlanActual(userData, planActual);
			let resumenCuenta = new Resumen();
			resumenCuenta.pagado = this.planActual.pagado;
			resumenCuenta.idPlanUsuario = this.planActual.idPlanUsuario;
			resumenCuenta.idPlanSf = this.planActual.idPlanSf;
			resumenCuenta.formaPago = this.planActual.formaPago;
			resumenCuenta.nombrePlan = this.planActual.nombrePlan;
			//this.resumenCuenta = resumenCuenta;
			this.notifyResumen(resumenCuenta);
		}
	}

	handlePlanActual(userData: any): void {
		this.planSeleccionado = this.planes.find((x) => x.id === this.planActual.idPlanSf);
		//this.planUsuarioPagado = planActual;
		if (!this.planActual.activo) {
			//this.idContratacion = planActual.idContratacion;
			this.certificaciones.forEach((x) => {
				x.idPlanUsuario = this.planActual.idPlanUsuario;
				x.solicitada = userData.certificacionesPendientes.some((y) => y.codigoPrincipal === x.codigoPrincipal);
			});
		}
		// El resumen (resumen-bloque) solo calcula montos cuando recibe este trigger;
		// si no se emite acá, queda en $0 hasta que el usuario interactúe manualmente (ej. mover el slider de meses).
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
		// TODO this.nmeses = planActual.meses;
		// TODO this.resumenCuenta.formaPago = planActual.formaPago;
	}

	handleError(error): void {
		console.log(error);
		Swal.fire({
			title: "Error en datos",
			text: "No fue posible obtener los datos del usuario actual, favor intente nuevamente",
			icon: "error",
		});
	}

	pagar() {
		if (this.loading || this.solicitandoFechaCertificacion) return;
		if (this.tieneDeudaGraciaPendiente) {
			Swal.fire({
				icon: "warning",
				title: "Tienes una regularización pendiente",
				text: "Para regularizar tu plan primero debes pagar la regularización por el uso durante el periodo de gracia.",
			});
			return;
		}

		if (this.tieneDeudaAdicionalPendiente) {
			Swal.fire({
				icon: "warning",
				title: "Tienes facturas pendientes por adicionales",
				text: "Para regularizar tu plan primero debes pagar la deuda pendiente por adicionales o certificaciones.",
			});
			return;
		}

		// Si hay certificaciones seleccionadas, abrir modal de fecha
		if (this.hayCertificacionesSeleccionadas) {
			this.abrirModalFechaCertificacion();
			return;
		}
		this.realizarPago();
	}

	pagarDeudaAdicional(): void {
		if (!this.tieneDeudaAdicionalPendiente || this.pagandoDeudaAdicional) return;

		if (!this.datosFacturacion?.emisorDatosId) {
			Swal.fire({
				icon: "warning",
				title: "Faltan datos",
				text: "No encontramos los datos de facturación de la empresa. Contacta a soporte para regularizar tu deuda.",
			});
			return;
		}

		this.pagandoDeudaAdicional = true;
		this.ref.detectChanges();

		this.planUsuarioService
			.payPendingAdditionalDebt({
				idUsuario: this.user.id,
				idEmisor: this.planActual?.emisorId ?? this.tokenService.getCompany(),
				idDatosFacturacion: this.datosFacturacion.emisorDatosId,
				idPlanUsuario: this.planActual?.idPlanUsuario,
			})
			.subscribe(
				(result) => {
					if (result.status === 200 && result.data?.pago === "webpay") {
						this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((pagado) => {
							this.pagandoDeudaAdicional = false;
							this.ref.detectChanges();
							if (pagado) {
								Swal.fire({
									icon: "success",
									title: "Deuda regularizada",
									text: "El pago de tus facturas pendientes fue registrado. Ahora puedes continuar con la regularización de tu plan.",
								}).then(() => this.cargarDatos());
							} else {
								Swal.fire({
									icon: "warning",
									title: "Pago en proceso",
									text: "No obtuvimos confirmación del pago. Si fue procesado, la deuda dejará de mostrarse en breves minutos.",
								}).then(() => this.cargarDatos());
							}
						});
					} else {
						this.pagandoDeudaAdicional = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error al procesar el pago",
							text: "No fue posible iniciar el pago de la deuda. Intenta nuevamente.",
						});
					}
				},
				(error) => {
					this.pagandoDeudaAdicional = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al procesar el pago",
						text: "No se pudo registrar el pago de la deuda. " + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			);
	}

	pagarDeudaGracia(): void {
		if (!this.tieneDeudaGraciaPendiente || this.pagandoDeudaGracia) return;

		if (!this.datosFacturacion?.emisorDatosId) {
			Swal.fire({
				icon: "warning",
				title: "Faltan datos",
				text: "No encontramos los datos de facturación de la empresa. Contacta a soporte para regularizar tu deuda.",
			});
			return;
		}

		this.pagandoDeudaGracia = true;
		this.ref.detectChanges();

		this.planUsuarioService
			.payDeudaGracia({
				idUsuario: this.user.id,
				idEmisor: this.planActual?.emisorId ?? this.tokenService.getCompany(),
				idDatosFacturacion: this.datosFacturacion.emisorDatosId,
				idPlanUsuario: this.planActual?.idPlanUsuario,
			})
			.subscribe(
				(result) => {
					if (result.status === 200 && result.data?.pago === "webpay") {
						this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((pagado) => {
							this.pagandoDeudaGracia = false;
							this.ref.detectChanges();
							if (pagado) {
								Swal.fire({
									icon: "success",
									title: "Regularización pagada",
									text: "El pago por el uso durante el periodo de gracia fue registrado. Ahora puedes continuar con la regularización de tu plan.",
								}).then(() => this.cargarDatos());
							} else {
								Swal.fire({
									icon: "warning",
									title: "Pago en proceso",
									text: "No obtuvimos confirmación del pago. Si fue procesado, la deuda dejará de mostrarse en breves minutos.",
								}).then(() => this.cargarDatos());
							}
						});
					} else {
						this.pagandoDeudaGracia = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "error",
							title: "Error al procesar el pago",
							text: "No fue posible iniciar el pago de la regularización. Intenta nuevamente.",
						});
					}
				},
				(error) => {
					this.pagandoDeudaGracia = false;
					this.ref.detectChanges();
					Swal.fire({
						icon: "error",
						title: "Error al procesar el pago",
						text: "No se pudo registrar el pago de la regularización. " + this.utilities.setErrorMessageFromArray(error.error),
					});
				}
			);
	}

	private async abrirModalFechaCertificacion(): Promise<void> {
		this.solicitandoFechaCertificacion = true;
		const modal = this.modalService.open(FechaCertificacionModalComponent, {
			size: 'md',
			backdrop: 'static',
			keyboard: false,
			ariaLabelledBy: 'fecha-certificacion-titulo',
		});

		let fecha: Date;
		try {
			fecha = await modal.result;
		} catch {
			// Cancelar o cerrar la selección de fecha no inicia el pago.
			return;
		} finally {
			this.solicitandoFechaCertificacion = false;
			this.ref.detectChanges();
		}
		this.resumenCuenta.fechaConfirmada = fecha;
		this.realizarPago();
	}

	private realizarPago() {
		this.loading = true;
		this.ref.detectChanges();
		this.resumenCuenta.idDatosFacturacion = this.datosFacturacion.emisorDatosId;
		this.resumenCuenta.idEmisor = this.planActual.emisorId;
		this.resumenCuenta.idUsuario = this.user.id;
		if (this.planSeleccionado.id != this.planActual.idPlanSf) {
			this.resumenCuenta.idPlanSf = this.planSeleccionado.id;
		} else {
			this.resumenCuenta.idPlanSf = this.planActual.idPlanSf;
		}
		this.certificaciones.forEach((x) => (x.idPlanUsuario = this.planActual.idPlanUsuario));
		this.resumenCuenta.certificaciones = this.certificaciones;
		this.planUsuarioService.doPayment(this.resumenCuenta).subscribe(
			(result) => {
				if (result.status == 200) {
					if (result.data.pago == "webpay") {
						//TODO: Esperar a que finalice el pago y generar factura  para enviarla a cliente
						this.webpayService.payWithWebpay(result.data.url, result.data.token).subscribe((paymentCompleted) => {
							this.loading = false;
							this.ref.detectChanges();
							if (paymentCompleted) {
								// Ejecutar la verificación de Transbank y continuar con la generación de la factura
								Swal.fire({
									icon: "success",
									title: "Pago realizado",
									text: "Se ha registrado exitosamente el pago",
								}).then((result) => {
									if (result.value) {
										this.changeCompanyService.cerrarModalPago();
										this.authService.logout().subscribe();
									}
								});
							}
						});
					}
					else if (SaldoPagoUi.esCoberturaTotal(result.data))
					{
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Compra completada con saldo",
							text: "La operación fue completada utilizando tu saldo a favor.",
						}).then((dialog) => {
							if (dialog.isConfirmed) {
								this.changeCompanyService.cerrarModalPago();
								this.authService.logout().subscribe();
							}
						});
					}
					else
					{
						this.loading = false;
						this.ref.detectChanges();
						Swal.fire({
							icon: "success",
							title: "Pago Ingresado",
							text: "Operación terminada. Si el pago fue realizado con éxito se verá reflejado en breves segundos",
						}).then((result) => {
							if (result.isConfirmed) {
								this.changeCompanyService.cerrarModalPago();
								this.authService.logout().subscribe();
							}
						});
					}
					
				}
			},
			(error) => {
				this.loading = false;
				if (SaldoPagoUi.esConflicto(error)) {
					SaldoPagoUi.limpiarSeleccion(this.resumenCuenta);
					solicitarRefrescoSaldo();
					Swal.fire({
						icon: "warning",
						title: "Tu saldo disponible cambió",
						text: "El saldo disponible cambió. Revisa el total actualizado y confirma nuevamente la compra.",
					});
					return;
				}
				Swal.fire({
					icon: "error",
					title: "Error al Ingresar el pago",
					text: "No se ha podido registrar el pago" + this.utilities.setErrorMessageFromArray(error.error),
				});
			}
		);
	}
	notifyResumen(resumen: Resumen): void {
		//this.nuevaFechaCaducidad = moment(this.planActual.fechaCaducidad).add(resumen.meses, "months");
		this.nuevaFechaCaducidad = moment(resumen.fechaTermino);
		this.resumenCuenta = resumen;
	}

	openCambiarEmpresa(showCloseButton: boolean) {
		this.changeCompanyService.cerrarModalPago();
		this.changeCompanyService.showModalSelectorEmpresa(showCloseButton);
	}

	cambiarEmpresa(fromChangeCompany: boolean) {
		this.tokenService.setCompany(this.currentEmisorObject.emisorId);
		this.tokenService.setCompanyRut(this.currentEmisorObject.rut);
		const currentSucursalId = this.tokenService.getSubsidiary();
		if (fromChangeCompany) {
			this.changeCompanyService.cerrarModalCambiarEmpresa();
		} else {
			this.changeCompanyService.cerrarModalPago();
		}
		this.changeCompanyService.SetNewCompany(this.currentEmisorObject, currentSucursalId);
	}

	updatePlan(plan: Plan) {
		this.planSeleccionado = plan;
		setTimeout(() => {
			this.pagoService.triggerCalculations();
		}, 0);
	}
	private actualizarEstadoEmpresas(): void {
        const sessionUser = this.tokenService.getUser() as SessionUser;

        if (sessionUser?.tieneEmpresasInactivas !== undefined) {
            this.tieneEmpresasInactivas = sessionUser.tieneEmpresasInactivas;
            this.cantidadEmpresasInactivas = sessionUser.cantidadEmpresasInactivas ?? 0;
            this.cantidadEmpresasActivas = sessionUser.cantidadEmpresasActivas ?? 0;
        } else {
            const inactivos = this.emisoresSource.filter((e) => !e.activo);
            this.cantidadEmpresasInactivas = inactivos.length;
            this.cantidadEmpresasActivas = this.emisoresSource.length - inactivos.length;
            this.tieneEmpresasInactivas = inactivos.length > 0;
        }
    }
	onEmpresaSeleccionada(emisor: Emisor): void {
        if (!emisor) return;
		this.currentEmisorObject = emisor;
        if (!emisor.activo && (emisor.resellerId == null || emisor.resellerId === '')) {
            this.changeCompanyService.handleSeleccionEmpresaInactiva(emisor);
        } else {
            this.cambiarEmpresa(true);
        }
    }
}
